import React, { Component } from "react";
import { Image, Checkbox, message } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import WidgetModal from "./../../widget/WidgetModal";
import ReactPDF from 'react-pdf-js';
import { Toast } from 'antd-mobile'
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import file from '../../img/business/file.png'
import files from '../../img/business/files.png'
import pdf from '../../img/business/pdf.png'
import word from '../../img/business/word.png'
import excel from '../../img/business/excel.png'
import { ExclamationCircleFilled } from '@ant-design/icons';
// import { Document, Page } from'react-pdf';
const filePath = Config.getFilePath();
class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listInfo: {},
            pageInfo: {},
            userInfo: {},
            industryInfo: {},
            provinceList: [],
            cityList: [],
            districtList: [],
            tipsInfo: {},
            visible: false,
            srcUrl: '',
            modal: null,
            modelOptions: {
                type: 'message',
                title: '提示',
                index: 0,
                label: 1,
                message: <div className="sg-index-bg" style={{ padding: '24px 0' }}>
                    <div className="sd-middle">
                        <img className='sg-bg-img12' alt='#' src={require('../../img/business/complete.png')} />
                    </div>
                    <div className="sg-filling-layer sd-middle">申报信息已提交审核，在申报期前都</div>
                    <div className="sg-filling-layer sd-middle">可对资料进行修改和完善</div>
                </div>,
                isNext: false,
                isOk: true,
                width: 300,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            pdfOptions: {
                title: 'PDF查看',
            },
            isHide: true,
            HJMC: ''
        }
        this.onOk = this.onOk.bind(this);
        this.onOkClick = this.onOkClick.bind(this);
    }
    componentDidMount() {
        this.setState({
            listInfo: this.props.location.state,
            HJMC: this.props.location.state.HJMC
        })
        this.querySqHisList(this.props.location.state.SQID)
        this.getUserInfo()
        this.queryAuditList()
    }
    queryAuditList() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_list',
            params: {
                SQID: this.props.location.state.SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setState({
                        tipsInfo: data.result
                    })
                    console.log(data)

                }
            }
        }, this);
    }
    getUserInfo() {
        let userInfo = localStorage.getItem("_user_info_")
        if (userInfo) {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            this.queryEntinfo(info)
        }

    }
    queryEntinfo(info) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/entinfo',
            params: {
                UNISCID: info.uniscid
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setState({
                        industryInfo: data.result || {}
                    })

                }
            }
        }, this);
    }
    queryProvince(type, filter, code) {
        let pageInfo = this.state.pageInfo
        let obj = {
            code: type,
            hierarchy: 1,
        }
        if (filter && code) {
            obj.filter = "${" + filter + "}=" + code

        }
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/widget/dimension',
            params: {
                dimension: obj
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results[0].values.forEach(da => {
                        da.label = da.name
                    })

                    if (!filter && !code) {
                        pageInfo.PROVINCESTR = data.results[0].values.find(res => { return res.value === pageInfo.PROVINCE }).name
                        this.setState({
                            provinceList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (filter === 'D111001' && !this.state.cityList.length) {
                        pageInfo.CITYSTR = data.results[0].values.find(res => { return res.value === pageInfo.CITY }).name
                        this.setState({
                            cityList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (filter === 'D111002' && !this.state.districtList.length) {
                        pageInfo.COUNTYSTR = data.results[0].values.find(res => { return res.value === pageInfo.COUNTY }).name
                        this.setState({
                            districtList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (!this.state.cityList.length) {
                        this.queryProvince('D111002', 'D111001', pageInfo.PROVINCE)
                    }
                    if (!this.state.districtList.length && this.state.cityList.length) {
                        this.queryProvince('D111003', 'D111002', pageInfo.CITY)
                    }
                }
            }
        }, this);
    }
    goPage() {
        window.history.back(-1)
    };
    querySqHisList(SQID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/info',
            params: {
                SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.result.SQRESULTS.forEach(da => {
                        if (da.ZBTMLX === '5') {
                            let RESULT = JSON.parse(da.RESULT)
                            RESULT.forEach(res => {
                                if (res.VCHRSTORAGENAME) {
                                    let newUrl = res.VCHRSTORAGENAME.split(',');
                                    res.imgUrl = filePath + (newUrl && newUrl.length > 1 ? newUrl[1] : newUrl[0])
                                    if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                        res.img = pdf
                                    } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                        res.img = word
                                    } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                        res.img = excel
                                    } else {
                                        res.img = files
                                    }
                                } else
                                    if (res.VCHRFILETYPE.indexOf('png') !== -1 || res.VCHRFILETYPE.indexOf('jpeg') !== -1 || res.VCHRFILETYPE.indexOf('jpg') !== -1 || res.VCHRFILETYPE.indexOf('gif') !== -1) {
                                        this.queryDownload(res, data.result, 'min')
                                    } else {
                                        if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                            res.img = pdf
                                        } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                            res.img = word
                                        } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                            res.img = excel
                                        } else {
                                            res.img = files
                                        }
                                        this.queryDownload(res, data.result, 'min')
                                    }
                            })
                            da.RESULT = RESULT
                        }
                    })
                    this.setState({
                        pageInfo: data.result
                    })
                    // this.queryProvince("D111001")
                }
            }
        });
    }
    getBase64(data) {
        return new Promise((resolve, reject) => {
            const blob = new Blob([data], { type: "image/jpeg" }); //类型一定要写！！！
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    arrayBufferToBlob(arrayBuffer, type) {
        //return new Blob([arrayBuffer], { type: filename });
        let blob = new Blob([arrayBuffer], { type: type });
        const blobUrl = URL.createObjectURL(blob);
        return blobUrl;
    }
    queryDownload(obj, pageInfo, type) {
        let fd = new FormData();
        fd.append("id", obj.ID);
        if (type) {
            fd.append("imgsize", type);
        }
        this.setState({ DownloadType: type })
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/attachment/info',
            params: fd,
            callback: async (data) => {

                let value = data.result;

                if (value.VCHRDESCRIPTION && value.VCHRDESCRIPTION !== "" && type == undefined) {
                    obj.imgUrl = filePath + value.VCHRDESCRIPTION
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                } else {
                    let newUrl = value.VCHRSTORAGENAME.split(',');
                    if (type && newUrl && newUrl.length > 2) {
                        obj.imgUrl = filePath + newUrl[1]
                    } else {
                        obj.imgUrl = filePath + newUrl[0]
                    }
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
            }
        });
    }
    goFilling() {
        this.props.history.push({ pathname: "/home/filling", state: { SQID: this.props.location.state.SQID } });
    }

    seeImg(da) {
        console.log(221, da);
        // if (da.VCHRFILETYPE === '.pdf') {
        this.setState({ pdf: da });
        this.pdfMoal.open()
        // } 
    }
    onOk(type) {
        if (this.state.modelOptions.label === 1) {
            this.goPage()
        } else {
            this.submitBtnFn()
        }
    }
    onOkClick(type) {
        if (this.state.modelOptions.label === 1) {
            this.goPage()
        } else {
            // this.submitBtnFn()
        }
    }
    submitBtn(num) {
        this.setTipsQuery(num)
        // const { pageInfo, districtStr } = this.state;
        // WidgetAjax.ajax({
        //     url : Config.getBasePath()+'/template/info', 
        //     params : {
        //         SSQXID: pageInfo.COUNTY || districtStr
        //     }, 
        //     callback : (data)=>{
        //         if(data&&data.status === 0){
        //             let endTimeStr = `${data.result.ENDTIME} 23:59:59`
        //             let endTimeNum = new Date(endTimeStr).getTime()
        //             if(new Date().getTime() > endTimeNum){
        //                 message.success('评审期已结束，无法继续申报！');
        //             }else{
        //                 this.setTipsQuery(num)
        //             }
        //         }
        //     }
        // },this);
    }
    setTipsQuery(num) {
        const { modelOptions } = this.state;
        modelOptions.label = 2
        modelOptions.okText = '确认'
        modelOptions.message = <div className="sg-index-body sd-columnCenter" style={{ padding: '0 0.1041rem ' }}>
            <ExclamationCircleFilled style={{ color: '#ff0000', fontSize: '38px' }} />
            <div style={{ marginTop: '12px' }}>您确认提交申报信息吗？</div>
            <div style={{ marginBottom: '28px', textAlign: 'center' }}>请确认申报信息准确无误，可在申报期内进行修改，进入审核后将不可修改</div>
        </div>
        this.setState({
            modelOptions: modelOptions,
        })
        this.modal.open();
    }
    onRef = (ref) => {
        this.modal = ref;
    };
    onPdfRef = (ref) => {
        this.pdfMoal = ref;
    }
    submitBtnFn() {
        let obj = {
            ZJ: this.props.location.state.SQID,         // 主键ID
            TASKID: this.state.pageInfo.TASKID,     // 任务ID
            JYZSFZ: this.state.pageInfo.JYZSFZ,     // 经营者身份证号
            JYZSJH: this.state.pageInfo.JYZSJH,     // 经营者手机号
            XNJYRS: this.state.pageInfo.XNJYRS,     // 吸纳就业人数
            JNSBRS: this.state.pageInfo.JNSBRS,     // 缴纳社保人数
            YYSR: this.state.pageInfo.YYSR,       // 营业收入(万元)
            JLR: this.state.pageInfo.JLR,        // 净利润(万元)
            PROFILE: this.state.pageInfo.PROFILE,    // 个体户简介
            SQTYPE: this.state.pageInfo.SQTYPE,     // 申请类型 1名 2 特 3优 4新
            SUMSCORE: this.state.pageInfo.SUMSCORE,   // 当前申请项总得分
            SQRESULTS: this.state.pageInfo.SQRESULTS,  // 申请指标结果集
            PROVINCE: this.state.pageInfo.PROVINCE,   // 省
            CITY: this.state.pageInfo.CITY,       // 市
            COUNTY: this.state.pageInfo.COUNTY,     // 区
            ISBF: this.state.pageInfo.ISBF,       // 是否帮扶
            SFTJ: 'Y'
        }
        let arr = []
        this.state.pageInfo.SQRESULTS.forEach(da => {
            let obj = {
                ZBMC: da.ZBMC,
                RESULT: da.RESULT,
                SCORE: 0,
                ZBTMLX: da.ZBTMLX,
                ZBID: da.ZBID
            }
            if (da.ZBTMLX === '2') {
                let ZBBZZ = JSON.parse(da.ZBBZZ)
                let info = ZBBZZ.find(res => { return res.name === da.RESULT })
                obj.SCORE = info ? info.score : da.ZBNUM
            }
            if (da.ZBTMLX === '3') {
                let ZBBZZ = JSON.parse(da.ZBBZZ)
                let list = ZBBZZ.filter(res => { return da.RESULT.indexOf(res.name) > -1 })
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? list.reduce((total, num) => { return total + num.score }, 0) : 0
                obj.RESULT = JSON.stringify(obj.RESULT)
            }
            if (da.ZBTMLX === '1') {
                // let info = da.ZBBZZ.find(res=>{return res.name === da.RESULT})
                obj.SCORE = da.RESULT === '是' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '4') {
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '5') {
                let arr = []
                obj.RESULT.forEach(da => {
                    arr.push({ ID: da.ID, VCHRFILETYPE: da.VCHRFILETYPE })
                })
                obj.RESULT = JSON.stringify(arr)
                obj.SCORE = obj.RESULT && obj.RESULT !== '[]' && obj.RESULT !== '{}' && obj.RESULT !== 'undefined' && obj.RESULT !== 'null' && obj.RESULT !== 'Null' && obj.RESULT !== 'NULL' ? da.ZBNUM : 0
            }
            arr.push(obj)
        })
        obj.SQRESULTS = arr
        this.queryUpdate(obj)
    }
    queryUpdate(params) {
        this.modal.onClose();
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/update',
            params: params,
            callback: (data) => {
                if (data && data.status === 0) {
                    message.success('申报信息已提交成功！');
                    this.setState({
                        listInfo: {
                            ...this.state.listInfo,
                            HJMC: '待审核'
                        },
                        HJMC: '待审核',
                    })
                    this.querySqHisList(this.props.location.state.SQID)
                    this.modal.onClose();
                } else {
                    message.success(data.message);
                }
            }
        }, this);
    }

    visibleChange = () => {
        const { pageInfo, DownloadType } = this.state;

        pageInfo.SQRESULTS.forEach(da => {
            if (da.ZBTMLX === '5' && DownloadType) {
                let RESULT = da.RESULT
                RESULT.forEach(async res => {
                    if (res.VCHRSTORAGENAME) {
                        let newUrl = res.VCHRSTORAGENAME.split(',');
                        res.imgUrl = filePath + (newUrl[0])
                        if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                            res.img = pdf
                        } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                            res.img = word
                        } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                            res.img = excel
                        } else {
                            res.img = files
                        }

                    } else
                        if (res.VCHRFILETYPE.indexOf('png') !== -1 || res.VCHRFILETYPE.indexOf('jpeg') !== -1 || res.VCHRFILETYPE.indexOf('jpg') !== -1 || res.VCHRFILETYPE.indexOf('gif') !== -1) {
                            await this.queryDownload(res, pageInfo)
                        } else {
                            if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                res.img = pdf
                            } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                res.img = word
                            } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                res.img = excel
                            } else {
                                res.img = files
                            }
                            await this.queryDownload(res, pageInfo)
                        }
                })
            }
        })
    }
    render() {
        const { pageInfo, industryInfo, visible, srcUrl, modelOptions, isHide, HJMC, pdf, pdfOptions } = this.state
        const ENTTYPE_OBJ = {
            '1': '生存',
            '2': '成长',
            '3': '发展'
        }
        const SQTYPE_OBJ = {
            '1': '“名”，即知名',
            '2': '“特”，即特色',
            '3': '“优”，即优质',
            '4': '“新”，即新兴',
        }

        return (
            <div key={pageInfo.UNISCID} data-component="basis">

                <div className="sg-basis" style={{ paddingBottom: ['草稿', '[县级]退回', '市审核退回', '省审核退回', '[市级]退回'].includes(HJMC) ? "2rem" : "0.32rem" }}>
                    <div className="sg-basis-title">基础信息</div>
                    <div className="sg-basis-center" style={{ paddingTop: 0, paddingBottom: 0, overflow: 'hidden' }}>
                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">个体工商户名称/字号</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.ENTNAME}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">统一社会信用代码</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.UNISCID}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">经营者姓名</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.NAME}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">注册日期</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.ESTDATE}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">省份/地市/区县</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.PROVINCE_STR}{pageInfo.PROVINCE_STR == pageInfo.CITY_STR ? '' : '/'}{pageInfo.PROVINCE_STR == pageInfo.CITY_STR ? '' : pageInfo.CITY_STR}/{pageInfo.COUNTY_STR}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">组成形式</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.COMPFORM !== 'null' && industryInfo.COMPFORM !== 'NULL' ? industryInfo.COMPFORM : ''}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">经营场所</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.OPLOC}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">登记机关</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.REGORG}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">经营范围</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{industryInfo.OPSCOPE}</div>
                        </div>

                        {/* <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">三型</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{ENTTYPE_OBJ[industryInfo.ENTTYPE_SX]}</div>
                        </div> */}

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">经营者身份证号码</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.JYZSFZ}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">经营者手机号码</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.JYZSJH}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">吸纳就业人数（人）</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.XNJYRS}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">缴纳社保人数（人）</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.JNSBRS}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">年营业收入（万元）</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.YYSR}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">年净利润（万元）</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.JLR}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">个体工商户介绍/简介</div>
                            <div className="sg-list-li sg-li-right1 sd-start">{pageInfo.PROFILE}</div>
                        </div>
                    </div>

                    <div className="sg-basis-center" style={{ marginTop: '8px' }}>
                        <div className="sg-middle-title sd-middle">
                            <div className="sg-title-title">
                                <span style={{ position: 'relative', zIndex: 2 }}>{SQTYPE_OBJ[pageInfo.SQTYPE]}</span>
                            </div>
                        </div>
                        {
                            pageInfo.SQRESULTS && pageInfo.SQRESULTS.map((res, i) => {
                                let str = ''
                                if (res.ZBTMLX === '1' || res.ZBTMLX === '2') {
                                    str = <div>
                                        <div className="sg-middle-li">{i + 1}、{res.ZBMC}</div>
                                        <div className="sg-li-answer">{res.RESULT}</div>
                                    </div>
                                }
                                if (res.ZBTMLX === '4') {
                                    str = <div>
                                        <div className="sg-middle-li">{i + 1}、{res.ZBMC}</div>
                                        <div className="sg-li-answer">{res.RESULT}</div>
                                    </div>
                                }
                                if (res.ZBTMLX === '5') {
                                    str = <div>
                                        <div className="sg-middle-li">{i + 1}、{res.ZBMC}</div>
                                        <div className="sg-li-li sd-start " style={{ flexWrap: 'wrap' }}>
                                          
                                            {
                                                res.RESULT && res.RESULT.map(item => {
                                                    return <div className="sd-img-li">

                                                        {
                                                            item.VCHRFILETYPE === '.png' || item.VCHRFILETYPE === '.jpeg' || item.VCHRFILETYPE === '.jpg' ||
                                                            item.VCHRFILETYPE === '.gif' || item.VCHRFILETYPE === '.webp' || item.VCHRFILETYPE === '.bmp' || item.VCHRFILETYPE === '.pict'
                                                                ?
                                                                <Image className='sg-li-img' src={item.imgUrl} preview={{ src: item.imgUrl }} onClick={this.visibleChange} />
                                                                :
                                                                item.fileUrl ?
                                                                    <div onClick={() => { window.open(item.fileUrl) }}>{/* 提供下载选项 */}
                                                                        <Image className='sg-li-img' src={item.img ? item.img : item.imgUrl} />
                                                                    </div>
                                                                    :
                                                                    <a target="_blank" href={item.imgUrl ? item.imgUrl : item.fileUrl}>{/* 提供下载选项 */}
                                                                        <Image className='sg-li-img' src={item.img ? item.img : item.imgUrl} />
                                                                    </a>
                                                        }

                                                        {/* {item.VCHRFILETYPE !== '.png' && item.VCHRFILETYPE != '.jpg' && item.VCHRFILETYPE != '.gif' ? (
                                                            item.fileUrl ?
                                                                <div onClick={() => { window.open(item.fileUrl) }}>
                                                                    <Image className='sg-li-img' src={item.img ? item.img : item.imgUrl} />
                                                                </div>
                                                                :
                                                                <a target="_blank" href={item.imgUrl ? item.imgUrl : item.fileUrl}>
                                                                    <Image className='sg-li-img' src={item.img ? item.img : item.imgUrl} />
                                                                </a>
                                                        ) : (
                                                            <Image className='sg-li-img' src={item.imgUrl} preview={{ src: item.imgUrl }} onClick={this.visibleChange} />
                                                        )} */}
                                                     
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                if (res.ZBTMLX === '3' && res.ZBBZZ) {
                                    str = <div>
                                        <div className="sg-middle-li"><span className="sg-left-color" style={{ display: res.SFBT === 1 || res.SFBT === '1' || res.SFBT === '是' ? "inline-block" : "none" }}>*</span>{i + 1}.{res.ZBMC}</div>
                                        <div className="sg-li-answer">
                                            <Checkbox.Group disabled onChange={(e) => this.changeCheckbox(e, i)} value={JSON.parse(res.RESULT)}>
                                                {
                                                    JSON.parse(res.ZBBZZ).map((item, num) => {
                                                        return <Checkbox value={item.name}>{item.name}</Checkbox>
                                                    })
                                                }
                                            </Checkbox.Group>
                                        </div>
                                    </div>
                                }
                                return str
                            })
                        }
                    </div>

                    <div className="sg-judge-bottom sd-end" style={{ display: ['[县级]退回', '市审核退回', '省审核退回', '[市级]退回'].includes(HJMC) ? "flex" : "none" }}>
                        <div className="sg-bottom-btn sd-middle" onClick={() => { this.submitBtn(1) }} >提交</div>
                    </div>
                </div>
                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk} onOkClick={this.onOkClick} onCancel={this.onOkClick}></WidgetModal>
                <WidgetModal options={pdfOptions} onRef={this.onPdfRef}>
                    <div style={{ overflow: 'auto' }}>
                        {

                            pdf ?
                                <ReactPDF file={pdf} />
                                : <></>

                        }
                    </div>
                </WidgetModal>
            </div>
        )
    }
}

export default Index
